import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import TokensExpiredError from "../errors/tokens-expired-error";
import { buildAuthenticationBody } from "../util/build-authentication-body";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";
import { UpdateGatewayNameTypes } from "@src/cloud-connect/use-cases/update-gateway-name";

export const putUpdateGatewayName = async (dto: UpdateGatewayNameTypes) => {
  try {
    const res = await fetch(`${appUrl()}/api/update-gateway-name`, {
      method: "POST",
      headers: buildAuthenticationHeaders(),
      body: JSON.stringify({
        ...buildAuthenticationBody(),
        name: dto.name,
        gateway_id: dto.gateway_id,
      }),
    });

    return { success: res.ok };
  } catch (err) {
    if (err instanceof TokensExpiredError) {
      navigateTo(Route.TOKENS_EXPIRED_ERROR);
    } else {
      return { success: false };
    }
  }
};
